<template>
  <div style="height: 100%; width: 100%; position: absolute;top: 0;left: 0">
    <div>
      <div
        class="searchMask"
        :style="{ width: subItem.width, height: subItem.height, left: subItem.x, top: subItem.y, background: subItem.bg ? subItem.bg : '' }"
        v-for="(subItem, subIndex) in item.posiArr"
        :key="subIndex"
        v-show="item.posiArr && item.posiArr.length > 0 && isShowYellow"
      ></div>
    </div>
    <div
      v-for="(coord, coordindex) in item.coordinates"
      v-bind:key="coordindex + 100"
      class="res-node area"
      :data-index="coordindex"
      :data-type="coord.type"
      :style="{
        top: coord.topScale + 'px',
        left: coord.leftScale + 'px',
        width: coord.widthScale + 'px',
        height: coord.heightScale + 'px',
        zIndex: coord.zIndex + 10
      }"
      @click="resNodeClick($event, coord, item)"
    ></div>
    <div
      v-for="(res, resindex) in item.resources"
      v-bind:key="resindex"
      v-show="!isloading"
      :class="{ 'res-node': true, audio: res.type === 'audio', video: res.type === 'video', link: res.type === 'link', picture: res.type === 'picture' }"
      :data-index="resindex"
      :data-type="res.type"
      :style="{
        top: res.topScale + 'px',
        left: res.leftScale + 'px',
        width: res.widthScale + 'px',
        height: res.heightScale + 'px',
        'z-index': res.type === 'picture' ? 1 : res.zindex + 1000001,
        'background-image': res.type === 'picture' ? `url(${res.path})` : ''
      }"
      @click="resNodeClick($event, res, item)"
    >
      <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : audioDefaultIcon" v-if="res.type === 'audio'" @click="resNodeImgClick($event, res)" v-singletap="resNodeImgSingletap" />
      <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : videoDefaultIcon" v-else-if="res.type === 'video'" @click="resNodeImgClick($event, res)" v-singletap="resNodeImgSingletap" />
      <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : linkDefaultIcon" v-else-if="res.type === 'link'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotArea',
  data() {
    return {
      linkDefaultIcon: require('@imgs/digital/link.png'),
      audioDefaultIcon: require('@imgs/digital/audio.png'),
      videoDefaultIcon: require('@imgs/digital/video.png')
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isloading: {
      default: false
    }
  },
  computed: {
    isShowYellow() {
      return this.$store.state.book.isShowYellow
    }
  },
  methods: {
    resNodeClick(e, res, item) {
      this.$emit('resNodeClick', e, res, item)
    },
    resNodeImgClick(e, res) {
      this.$emit('resNodeImgClick', e, res)
    },
    resNodeImgSingletap(e, res) {
      this.$emit('resNodeImgSingletap', e)
    }
  }
}
</script>
<style>
.searchMask {
  background: orange;
  opacity: 0.5;
  position: absolute;
  z-index: 20000;
}
.res-node {
  position: absolute;
  img {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
  }
}
.area {
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
.link {
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
.picture {
  background-size: contain;
  background-repeat: no-repeat;
}
.audio {
  img {
    cursor: pointer;
  }
}
.video {
  img {
    cursor: pointer;
  }
}
</style>
